import { Pipe, PipeTransform } from '@angular/core';
import { MoneyModel } from '../models/base.models';
import { TranslocoService } from '@jsverse/transloco';


@Pipe({
  name: 'moneyFormat'
})
export class MoneyFormatPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}
  transform(money: MoneyModel, refresher?: any): string {
    console.log(refresher);

    if (!money || !money.value || !money.currency) {
      return ''; // Handle cases with missing data
    }

    return `${money.currency.symbol}${money.value}${this.translocoService.translate(money.currency.code)}`;
  }
}
